import React        from 'react';
import PropTypes    from 'prop-types';
import Slick        from 'react-slick';
import Flux         from '../../flux/Flux';
import ReloadHelper from '../../utils/ReloadHelper';

const SLIDER_SETTINGS = {
	dots:           false,
	infinite:       false,
	speed:          500,
	arrows:         true,
	draggable:      false,
};

const AVATAR_DEFAULT = Flux.Constants.Placeholders.Avatar.FEMALE;

class ActorCardsSlider extends React.Component {

	constructor(props) {
		super(props);
		this.state          = {
			slides: props.slides, // ! default is now from props (default props)
		};
		this.onBonusModels  = this.onBonusModels.bind(this);
		this.onClickHandler = this.onClickHandler.bind(this);
	}


	componentDidMount() {
		Flux.Vxql.getBonusModels(this.onBonusModels);
	}

	onBonusModels(result) {
		this.setState({
			slides: result.data.dailyBonus.models,
		});
	}

	onClickHandler(e, link) {
		ReloadHelper.reload(link, e);
	}

	render() {
		let {slides} = this.state;
		if (!slides) {
			slides = this.props.slides;
		}
		SLIDER_SETTINGS.slidesToShow   = slides.length > 3 ? 3 : slides.length;
		SLIDER_SETTINGS.slidesToScroll = SLIDER_SETTINGS.slidesToShow;
		return (
			<div className='ui-slider'>
				<Slick {...SLIDER_SETTINGS}>
					{
						slides.map((slide, index) => {
							const avatar = slide.avatar && slide.avatar.url ? slide.avatar.url : AVATAR_DEFAULT;

							return (
								<div key={index} className='ui-slider__slide'>
									<div style={{backgroundImage: `url(${avatar})`}}
									     className={`ui-slider__slide--wrapper ${SLIDER_SETTINGS.slidesToShow < 3 ? 'fix-height' : 'flex-height'}`}
									>
										<a onClick={e => (this.onClickHandler(e, slide.profileLink))} href={slide.profileLink} className="ui-slider__slide--wrapper__inner">
											<h2>{slide.name}</h2>
											{slide.profile.showText.length > 0 ? <p>„{slide.profile.showText}“</p> : <p>&nbsp;</p>}
										</a>
									</div>
								</div>
							);
						})
					}
				</Slick>
			</div>
		);
	}
}

ActorCardsSlider.propTypes = {
	slides: PropTypes.arrayOf(PropTypes.shape({
		name:        PropTypes.string,
		profileLink: PropTypes.string,
		profile: PropTypes.shape({
			showText: PropTypes.string,
		}),
		avatar:      PropTypes.shape({
			url: PropTypes.string,
		}),
	})),
};

ActorCardsSlider.defaultProps = {
	slides: [
		{
			name:        'Loading ...',
			profileLink: '#',
			avatar:      {
				url: Flux.Constants.Placeholders.Avatar.FEMALE,
			},
			profile:     {
				showText: '',
			},
		},
		{
			name:        'Loading ...',
			profileLink: '#',
			avatar:      {
				url: Flux.Constants.Placeholders.Avatar.FEMALE,
			},
			profile:     {
				showText: '',
			},
		},
		{
			name:        'Loading ...',
			profileLink: '#',
			avatar:      {
				url: Flux.Constants.Placeholders.Avatar.FEMALE,
			},
			profile:     {
				showText: '',
			},
		},
	],
};

export default ActorCardsSlider;

